
import Vue from "vue";

export default Vue.extend({
  name: "SelectTag",
  props: {
    tagId: Number,
    selected: Boolean,
  },
  computed: {
    clazz(): string {
      let result = "hashtag badge ";
      if (this.selected) {
        result += "badge-primary";
      } else {
        result += "badge-secondary";
      }
      return result;
    },
    memberName(): string {
      switch (this.tagId) {
        case 2: return "律月ひかる";
        case 3: return "北美梨寧";
        case 4: return "葉月結菜";
        case 5: return "安杜羽加";
        case 6: return "吉瀬真珠";
        case 7: return "橘花怜";
        case 8: return "桜ひなの";
        case 9: return "藤谷美海";
        case 10: return "伊達花彩";
        default: return "";
      }
    },
  },
  methods: {
    click() {
      this.$emit("click", this.tagId);
      return false;
    },
  },
});

